import { ReactElement } from "react";
import { FiLinkedin } from "react-icons/fi";
import ScrollAnimation from "react-animate-on-scroll";

const DefaultTeamData = [
  {
    image: "mohammed",
    name: "Mohammed Moftah",
    designation: "Co-founder; CEO",
    location: "New York City",
    description:
      "Mohammed is a Software Engineer with experience at Google, Microsoft, and Amazon. Mohammed attended Rensselaer Polytechnic Institute where he received his dual Bachelors in Computer Science and Information Technology + Web Sciences, and Masters in Information Technology.",
    socialNetwork: [
      {
        icon: <FiLinkedin />,
        url: "https://www.linkedin.com/in/mmoftah97",
      },
    ],
  },
  {
    image: "adam",
    name: "Adam Moftah",
    designation: "Co-founder; COO",
    location: "New York City",
    description:
      "Adam is a designer, developer, and product manager with experience in various startup environments. Adam attended Yale University where he studied graphic design, animation, and computer science. Adam then went on to attend App Academy, an intensive web development bootcamp.",
    socialNetwork: [
      {
        icon: <FiLinkedin />,
        url: "https://www.linkedin.com/in/adam-moftah",
      },
    ],
  },
];

const TeamOne = ({ column, teamStyle }) => {
  return (
    <div className="row row--15 justify-content-center">
      {DefaultTeamData.map((data, index) => (
        <div className={`${column}`} key={index}>
          <div className={`rn-team ${teamStyle}`}>
            <ScrollAnimation
              animateIn="fadeInUp"
              animateOut="fadeInOut"
              animateOnce={true}
            >
              <div className="inner">
                <figure className="thumbnail">
                  <img src={`./images/team/${data.image}.jpg`} alt="Location" />
                </figure>
                <figcaption className="content">
                  <h2 className="title">{data.name}</h2>
                  <h6 className="subtitle theme-gradient">
                    {data.designation}
                  </h6>
                  {data.location && (
                    <span className="team-form">
                      <img src="./images/team/location.svg" alt="Location" />
                      <span className="location">{data.location}</span>
                    </span>
                  )}
                  <p className="description">{data.description}</p>

                  {data.socialNetwork && (
                    <ul className="social-icon social-default icon-naked mt--20">
                      {data.socialNetwork.map((social, index) => (
                        <li key={index}>
                          <a target="_blank" href={`${social.url}`}>
                            {social.icon}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </figcaption>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeamOne;
